import React from "react";
import CNEPTable from "./CNEPTable/CNEPTable";

export default function CNEPCard(props) {
    const { cnep_data } = props
    const hasSource = Object.keys(cnep_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                CNEP - Match encontrado
            </p>
            <CNEPTable cnep_data={cnep_data.source} />
        </div>
    )
}
